export default __webpack_public_path__ + "static/media/chart.b19a186c.svg";